<div class="backdrop backdrop_full-size">
    <div class="backdrop-content backdrop_full-size">
        <div class="backdrop-circle backdrop-circle1"></div>
        <div class="backdrop-circle backdrop-circle2"></div>
        <div class="backdrop-circle backdrop-circle3"></div>
    </div>
</div>
